export default {
  header: '订单及销售管理',
  title: '订单及销售管理',
  agentInfo: {
    header: '顾问资料',
    agent: '顾问',
    agentSplitRate: '顾问分成',
    isActive: '活跃',
    isServiceAgent: '主要顾问',
    effectiveDate: '有效日期',
    expiryDate: '无效日期',
    totalSplitRate: '总比率 :',
    deleteAgentConfirm: '<h5>你确认删除 <span class="text-danger">Delete</span> agent with contents below?</h5> <p>Agent English Name: {agentEnglishName}</p><p>Agent Chinese Name: {agentChineseName}</p>'
  },
  contents: {
    general: {
      agentRemarks: '顾问备注',
      renewal: "续保",
      page: '页',
      total: '总数',
      items: '项目',
      life: '人寿',
      gi: '一般保险',
      detail: '内容',
      delete: '删除',
      deleteSuccess: '成功删除保单!',
      deletePolicyConfirm: '<h5>你要确认 <span class="text-danger">Delete</span> policy with contents below?</h5> <p>Policy Number: {policyNumber}</p><p>Policy Reference : {policyRef}</p>',
      attachment: '附件',
      actions: '行动',
      create: '新增',
      policyStatus: '保单状态',
      workFlowStep: '流程步骤',
      updateTime: '最后更新时间',
      serviceRequest: { title: '服务申请' },
      outstandingRequirement: { title: '未完成的要求' },
      rejectedPolicy: '已被拒保单',
      completedPolicy: '已完成保单',
      rejectedPolicyModal: '<p>你已成功否决保单了。</p><p>此页会被转到 {type} Policy List.</p>',
      completedPolicyModal: '<p>你已完成保单了。</p><p>此页会被转到 {type} Policy List.</p>',
      addRiderConfirm: '你确认要加保单附件 {name} 于此保单 ?',
      removeRiderConfirm: '你确认要移除保单附件  {name} 由此保单 ?',
      changeBusiness: {
        title: 'Change Business',
        lapseDate: '保单失效日期',
        surrenderDate: '退保日期',
        reinstateDate: '复保日期',
        transferOut: '保单转出',
        transferIn: '保单转入',
        changePremiumType: '转换续保期数',
        confirmActionContent: '<p><b>保单号码:</b> {policyNumber}</p><p><b>保单持有人:</b> {policyOwner}</p>',
        confirmActionWarning: '<p>确认 {action} 此保单?</p>',
        transferInConfirm: '确认转入此保单?',
        lapse: '失效',
        surrender: '退保',
        reinstate: '复保',
      }
    },
    lifePolicy: {
      header: '人寿保单',
      new: ' 新增人寿保单',
      generalInfo: '一般资料',
      general: '一般',
      internalUse: '只供内部使用',
      currentWorkflow: '流程',
      policyStatus: '状态',
      policyType: '种类',
      payment: '付款',
      lifePolicy: '人寿保单',
      lifePolicyList: '人寿保单列表',
      lifeDetail: '内容',
      lifeOr: '未完成的要求',
      lifeTransferIn: '转入',
      workflowCreate: '新增',
      workflowConfirm: '确认',
      workflowSentOut: '送出',
      workflowUnderwriting: '核保中',
      workflowInforce: '已生效',
      workflowReject: '否决',
      workflowCompanyReceive: '公司收到',
      workflowAgentReceive: '顾问收到',
      workflowCustomerReceive: '客户收到',
      generalInformation: {
        policyAgent: '顾问',
        approveAgent: '顾问批准',
        policyStatus: '保单状态',
        riders: {
          title: '附加条款',
          description: '描述',
          riderPremium: '附加条款保单',
          riderStatus: '附加条款状态'
        },

        approveAgent: '审批者',
        paymentTerm: '供款年期',
        paymentMode: '付款方式',
        attachment: '附件',
        workFlowStep: '流程步骤',
        productName: '产品名称',
        policyNumber: '保单号码',
        policyReference: '参照保单',
        policyTerm: '保单年期',
        policyCurrency: '保单货币',
        premiumType: '保费期距',
        initialPremium: '初始保费',
        modalPremium: '每期保费',
        totalPremiums: '总保费',
        applicationDate: '申请日期',
        applicationReceivedDate: '收到申请日期',
        conditionalAssignmentFlag: 'Conditional Assignment Flag',
        originalAgent: '原有顾问',
        currentAgent: '现时顾问',
        originalReferrer: '推荐人',
        policyOwner: '保单持有人',
        insurer: '受保人',
        beneficiary: '受益人',
        thirdParty: '第三方',
        remarks: '备注',
        docs: '文件上载',
        paymentDate: '付款日期',
        paymentMethod: '付款方式',
        paymentAmount: '付款数目',
        sentOutDate: '送出日期',
        sentOutMedium: '送出媒介',
        sentOutReference: '送出参考数',
        companyBank: '公司银行',
        paymentReference: '付款参照',
        commencementDate: '开始日期',
        issueDate: '签发日期',
        welcomeLetterSentOutDate: '欢迎信送出日',
        companyReceiveDate: '公司收到日期',
        agentReceiveDate: '顾问收到日',
        customerReceiveDate: '官户收到日',
        //
        levy: '政府征费'
      }
    },
    giPolicy: {
      header: '一般保险单',
      new: '新增一般保险单',
      generalInfo: '一般资讯',
      policyInfo: '保单资料',
      general: '一般',
      fee: '费用',
      internalUse: '内部',
      commission: '佣金',
      payment: '付费',
      policyAgent: '顾问',
      currentWorkflow: '流程',
      policyStatus: '保单状态',
      policyType: '类别',
      giPolicy: '一般保险单',
      giPolicyList: '一般保险单列表',
      giPolicyDetail: '内容',
      giOr: '未完成的要求',
      workflowCreate: '新增',
      workflowConfirm: '确认',
      workflowSentOut: '送出',
      workflowUnderwriting: '核保',
      workflowInforce: '生效',
      workflowReject: '否决',
      workflowCompanyReceive: '公司收到',
      workflowAgentReceive: '顾问收到',
      workflowCustomerReceive: '客户收到',

      generalInformation: {
        policyAgent: '顾问',
        approveAgent: '审批顾问',
        attachment: '附件',
        actions: '行动',
        policyStatus: '保单状态',
        workFlowStep: '流程步骤',
        updateTime: '上次更新时间',
        policyOwnerName: '保单持有人名称',
        currentAgentName: '现时顾问名称',
        productName: '产品名称',
        policyNumber: '保单号码',
        policyReference: '保单参考数',
        applicationDate: '申请日期',
        applicationReceiveDate: '申请收到日期',
        policyCurrency: '保单货币',
        policyType: '保单类别',
        modalPremium: '每期保费',
        premiumPaid: '已缴保单',
        premiumType: '保费期距',
        premiumTypeOptions: {
          annual: '年缴',
          halfYear: '半年缴',
          quater: '季缴',
          month: '月缴'
        },
        actuallyPaid: '已付',
        paymentMethod: '付款方式',
        paymentAmount: '付款金额',
        companyBank: '公司银行',
        paymentReference: '付款参考数',
        paymentMethodOptions: {
          cheque: "支票",
          bankTransfer: "银行转帐",
          bankIn: "银行入数"
        },
        docs: '文件上载',
        paymentDate: '付款日期',
        originalAgent: '原顾问',
        currentAgent: '现时顾问名',
        ownerCustomer: '保单持有人',
        policyFee: '保单费用',
        insuredCustomer: '受保客户',
        agentCommissionRate: '顾问佣金率(%)',
        agentCommissionPaid: '顾问佣金率已付',
        newBusinessOrRenewal: '新生意或续保',
        newBusinessOrRenewalOptions: {
          newBusiness: '新生意',
          renewal: '续保',
          pleaseSelect: '--  请选择保单类别 --'
        },
        levyOrMIB: '政府征费 or 车保局',
        remarks: '备注',
        premiumPaid: '已付保费',
        insurerRebate: '保险公司回赠',
        chequeToInsurer: '给保险公司支票',
        chequeToInsurerNumber: '保险公司支票号码',
        chequeIssueDate: '支票发出日',
        sentOutDate: '送出日期',
        sentOutMedium: '送出方式',
        sentOutReference: '送出参考数',
        sentOutMediumOptions: {
          email: '电邮',
          courier: '快递',
        },
        courierNo: '快递号码',
        effectiveDate: '生效日期',
        expiryDate: '终结日期',
        issueDate: '签发日期',
        companyReceiveDate: '公司收到日期',
        agentReceiveDate: '代理收到日期',
        customerReceiveDate: '客户收到日期'
      },
      productInformation: {
        //Travel
        coverageType: '保障类别',
        packageType: '套票类别',
        travelType: '旅行类别',
        days: '日数',
        destination: '目的地',

        //contrator all risk
        contractSum: '合约总额',
        limitOfIndemnity: '赔款限额',
        nameOfInsured: '受保人名称',
        nameOfPrincipal: '主要人名称',
        natureOfBusiness: '业务性质',
        periodOfInsurance: '受保期间',
        riskLocation: '风险地点',
        typeOfCoverage: '保障范围类别',

        //Domestic helper
        coverage: '受保范围',
        insurancePeriod: '受保期间 (月)',
        nameOfEmployee: '雇主名称',
        placesEmployed: '受雇地点',

        //employee comp
        employeeRiskRate: '雇员风险率',
        estAnnualSalary: '预计薪金',
        occupation: '职业',

        riskRate: '风险率',
        mortgagee: '房贷',

        //healthMedical
        optionalBenefits: '可选保障',
        relationship: '关系',
        typeOfHealth: '健康类别',
        typeOfPlan: '计划类别',

        //home protection
        grossArea: '总面积',
        homeContent: '家居财物',
        propertyAge: '物业年龄',

        //motor
        bodyType: '车身类别',
        capacity: '车容量',
        chassisNumber: '车架编号',
        coverageType: '保障范围类别',
        engineNumber: '引击号码',
        hirePurchaseOwner: '租购人',
        makeAndModel: '厂商及型号',
        namedDriver: '司机名称',
        ncb: '免赔额',
        seatsExcDriver: '座位不包括司机',
        sumInsured: '保额',
        typeOfVehicle: '车辆类别',
        vehicleNumber: '车辆号码',

        //office Package
        numberOfEmployee: '雇员名称',
        officeContent: '办公室财物',
        officeRiskRate: '办公室风险率',
        title: '主题',

        //personal accident
        acciDeathNPermDisableAmt: '意外死亡及永久残疾额',
        acciDeathNPermDisablePrem: '意外死亡及永久残疾保费',
        acciMediExpPerAcciAmt: '每意外额的意外医疗费用',
        acciMediExpPerAcciPrem: '每意外保费的意外医疗费用',
        classOfOccupation: '职业类别',
        hosCashAllowPerDayAmt: '每日医疗现金',
        hosCashAllowPerDayPerm: '每日保费的医疗现金',
        incomeProtPerYrAmt: '每年收入保障额',
        incomeProtPerYrPerm: '每年收入保障/每年保额',

        //shop package
        stock: '存货',
        stockRiskRate: '货物风险率',

        //china medical card
        occupation: '职业',
        planCovered: '受保计划',

        //machinery all risk
        insuredPremises: '受保资产',
        itemDescription: '项目描述',

        //property all risk
        riskLocation: '风险地点',

        //marine cargo
        nameOfAssured: '受保名称',
        vesselName: '货船名称',
        voyage: '旅程',
        content: '财物',

        //group personal accident
        scopeOfCover: '保障范畴',
        aggrateLimit: '累计限额',
        totalHeadcount: '总人数',

        //product liability
        businessNature: '业务性质',
        productDescription: '产品描述',
        turnover: '生意颠'
      }
    }
  },

  serviceRequest: {
    original: '原有资料',
    new: '新资料',
    comparison: '比较',
    serviceType: '服务类别',
    comment: '意见',
    receiveTime: '收到时间',
    completeTime: '完成时间',
    approval: '审批',
    header: '服务请求',
    srList: '列表',
    approve: '通过',
    reject: '否决',
    select: {
      header: '选择服务请求',
      type: '请求类别'
    },
    'workflow-1': '新增服务请求',
    'workflow-2': '更新服务请求状态',
    agent: '搜寻顾问',
    customer: '搜寻客户',
    policyType: '保单类别',
    status: '服务请求状态',

    select: {
      header: '选择服务请求',
      agent: '顾问',
      policyDetail: '保单资料',
      policyStatus: '保单状态',
      policyValue: '保单价值',
    },

    confirm: {
      header: '确认',
      body: {
        approve: '确认要通过这个服务请求吗',
        reject: '确认要否决这个服务请求吗'
      }
    },

    type: {

      CPM: {
        header: '改变付款方法',
        paymentMethod: '付款方式',
        paymentReference: '付款参考号',
        companyBank: '公司银行',
        paymentDate: '付款日期',
        paymentStartDate: '付款开始日期',
        paymentEndDate: '付款完结日期',
      },
      CAS: {
        header: 'Assignment',
        initialAgent: 'Initial Agent',
        currentAgent: 'Current Agent',
      },
      CBF: {
        header: '转变受益人',
        beneficiary: '受益人'
      },
      CPO: {
        header: '改变付款方式',
        paymentMode: '付款方式'
      },
      CGA: {
        header: '改变保费额',
        modalPremium: '每期保费'
      },
      CPA: {
        header: '改变保费额',
        premiumAmount: '每期保费'
      },
      PLO: {
        header: '保单贷款',
        currentLoanAmount: '现时贷款额'
      },
      PSE: {
        header: '保单结算',
        currentLoanAmount: '现时贷款额'
      },
      PAU: {
        header: '清缴保费',
        policyPaidUpDate: '已清缴日期'
      },
      REI: {
        header: '复效保单'
      },
      SUR: {
        header: '退保',
        policyEndDate: '保单完结日期'
      },
      SUS: {
        header: 'Suspension'
      },
      WID: {
        header: '提款',
        totalWithdrawals: '总提款额'
      },
      CRI: {
        header: '改变附加条款',
        removeRider: '删除附加条款',
        recoverRider: '回复附加条款',
        newRider: '新增附加条款',
        riderProduct: '附加条款产品',
        riderPremium: '附加条款保费'
      },
      CPB: {
        header: '改变保额',
        modalPremium: '每期保费'
      },
      HOL: {
        header: '改变保单假期'
      },
      TRO: {
        header: '转出保单',
        policyEndDate: '保单完结日期'
      },
      GAS: {
        header: 'Assignment',
        currentAgent: 'Current Agent'
      },
      LAP: {
        header: '人寿保单失效',
        policyLapseDate: '保单失效日期'
      },
      GAP: {
        header: '一般保单失效',
        policyLapseDate: '保单失效日期'
      },
      DSA: {
        header: '基金转换权力下放'
      },
      MTA: {
        header: '强积金资产转换'
      },
      SRD: {
        header: '基金转换及改变供款'
      },
    }
  },
  provider: {
    header: '保险公司',
    providerCode: '保险公司编号',
    edit: {
      header: '编辑',
    },
    delete: {
      header: '删除',
      confirmDelete: '<h5>确认要 <span class="text-danger">删除</span> 保险公司以下内容?</h5> <p>Provider Code: {providerCode}</p><p>Provider Chinese Name: {providerChineseName}</p><p>Provider English Name: {providerEnglishName}</p>'
    },
    create: {
      header: '新增保险公司',
      providerEnglishName: '保险公司英文名',
      providerChineseName: '保险公司中文名',
      providerDescription: '保险公司描述',
      providerCountry: '保险公司国家',
      splitRate: "分成比率(%)",
      splitRate2: "分成比率 2(%)",
    },
    list: {
      header: '保险公司名单',
      providerName: '保险公司名称',
      updateTime: '最后更新'
    }
  },
  product: {
    header: '产品',
    create: {
      header: '新增产品',

    },
    list: {
      header: '产品名单',
      updateTime: '最后更新',
    },
    delete: {
      header: '删除产品',
      confirmDelete: '<h5>确认要 <span class="text-danger">删除</span> 以下的产品内容?</h5><table><tr><td><b>Product Code:</b></td><td>{productCode}</td></tr><tr><td><b>Product Chinese Name:</b></td> <td>{productChineseName}</td></tr><tr><td><b>Product English Name:</b></td><td>{productEnglishName}</td></tr><table>'
    },
    edit: {
      header: '编辑产品',
    },
    productName: '产品名称',
    productCode: '产品编号',
    productCodeByIssuer: '保险公司提供的产品编号',
    productEnglishName: '产品英文名',
    productChineseName: '产品大文名',
    productType: '产品类别',
    remarks: '备注',
    status: '状态',
    effectiveDateFrom: '有效期由',
    effectiveDateTo: '有效至',
    policyFeeHkd: '保单费用 (HKD)',
    policyFeeUsd: '保单费用 (USD)',
    allowCommissionRateOver100: '容许佣金高于 100%',
    commissionEffectiveFrom: '佣金有效期由',
    commissionEffectiveTo: '佣金有效期至',
    firstYearCommissionRate: '首年佣金率',
    year1Override: '首年下线抽成率（%)',
    year2Override: '次年下线抽成讯(%)',
    year1AnnualBonus: '首年年终奖金(%)',
    year2AnnualBonus: '次年年终奖金(%)',
    yearComm: '年 {年} 佣(%)',
    cutoffType: 'Cutoff Type',
  },
  renewal: {
    header: '绩保',
    list: {
      modalPremium: '期间保费',
      nextPaymentDateFrom: '付款日期由',
      nextPaymentDateTo: '付款日期至',
      policyType: '保单类别',
      header: '续保纪录列表',
      nextPaymentDate: '下次付款日期',
      showRecentOnly: '只显示最近纪录'
    },
    dueIn: '付款到期于',
    renew: '续保',
    renewLife: {
      header: '人寿续保',
      period: '期间',
      actualPaymentDate: '真实付款日期',

    },
  },
  claim: {
    header: '赔偿',
    apply: '申请赔偿',
    policyReference: '保单参考号',
    policyType: '保单类别',
    status: '状态',
    agentName: '顾问名称',
    claimType: '赔偿类别',
    expectedClaimAmount: '预期赔偿额',
    updateTime: '更新时间',
    agentCode: '顾问编号',
    claimRequestDate: '赔偿申请日期',
    claimResponseDate: '赔偿回覆日期',
    policy: '保单',
    remark: '备注',
    claimResult: '赔偿结果',
    companyReceiveDate: '公司收到日期',
    agentReceiveDate: '顾问收到日期',
    customerReceiveDate: '客户收到日期',
    claimIssueDate: '赔偿签发日期',
    claimPaymentMethod: '赔偿付款方式',
    claimReference: '赔偿参照号',
    claimAmount: '赔偿额',
    detail: {
      header: '赔偿内容'
    },
    list: {
      header: '赔偿列表',
    },
    create: {
      header: '新增赔偿',
      'workflow-1': '申请赔偿',
      'workflow-2': '处理中',
      'workflow-3': '赔偿内容',
      'workflow-4': '已完成赔偿',
      confirmModal: '<h5>确认要 <b class="text-danger">{action}</b> 这个赔偿?</h5>',
      claimResultModal: '<h5>确认要 <b class="text-danger">{action}</b> 这个赔偿结果?</h5>',
      saveResult: '储存',
      createResult: '新增',
    }
  }

}



// WEBPACK FOOTER //
// ./src/Osm/langs/zh_cn/index.js